import React, { useEffect, useState } from "react"
import "../styles/login.css"
import { useAuthUser } from "../context/authuser"
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";


function Login() {
  const router = useNavigate()
  const { liveUser } = useAuthUser();
  const { login } = useAuthUser();
  const [user, setUser] = useState({
    email: "",
    password: ""
  })

  useEffect(() => {
    if (liveUser) {
      router("/home")
    }
  }, [liveUser, router])


  function handleChange(e) {
    const { name, value } = e.target
    setUser({
      ...user,
      [name]: value

    })

  }


  async function Submit(e) {
    e.preventDefault();
    try {
      await login(user.email, user.password)
      router("/home")
      localStorage.setItem("pass", "true")
      toast.success("Login successfully 🔥🔥🔥")

    } catch (err) {
      toast.error("invalid credentials")
      console.log(err)
    }

    setUser({ email: "", password: "" })
  }


  return (
    <div className="login">
      <div className="login-bg">
        <form onSubmit={Submit}>
          <h4 className="welcome">Login</h4>

          <div className="user-data">
            <input className="name"
              required

              type="text"
              placeholder="email"
              value={user.email}
              name="email"
              onChange={handleChange}

            /><br />
            <input className="number"
              required
              type="password"
              placeholder="password"
              name="password"
              value={user.password}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="login-btn">Login</button>
          <p className="sign">Already have account <Link to="/" className="sign">SignUp ?</Link></p>

        </form>

      </div>


    </div>
  )
}

export default Login;